import {initWJPackage} from './wj-package.js';
import {initWJPackagePricedetails} from './wj-package-pricedetails.js';
import {initWJPackageEnergySources} from './wj-package-energysources.js';
import {initWJPackageTariff} from './wj-package-tariff.js';
import {initWJPackageReviews} from './wj-package-reviews.js';
import {initBCPackageSupplierDetails} from './bc-package-supplierdetails.js';
const initPackageComponents = () => {
  initWJPackageTariff();
  initWJPackageReviews();
  initWJPackagePricedetails();
  initWJPackageEnergySources();
  initBCPackageSupplierDetails();
  initWJPackage();
};
export {initPackageComponents};
